import LiveFeed from "./LiveFeed";
import { LocLabel } from "./LocationIcons";
import { IcChair } from "./Icons";

export default function TablesTab({ tables, sessions, onViewSession }) {
  // Group by location
  const ic  = tables.filter(t => t.location === "ic");
  const dis = tables.filter(t => t.location === "dis");

  const getTableSession = (tableId) => sessions.find(s => s.table_id === tableId);

  const renderTableCard = (table) => {
    const session    = getTableSession(table.id);
    const hasSession = !!session;

    return (
      <div
        key={table.id}
        className={`tables-tab-card${hasSession ? " has-session" : ""}`}
        onClick={() => hasSession && onViewSession(session.id)}
        style={{ cursor: hasSession ? "pointer" : "default" }}
      >
        <div className="ttc-label">{table.label}</div>
        <div className="ttc-code">{table.code}</div>

        {hasSession ? (
          <div className="ttc-session-info">
            <div className={`ttc-session-badge${session.status === "PARTIALLY_PAID" ? " partial" : ""}`}>
              {session.status === "PARTIALLY_PAID" ? "Kısmi Ödeme" : "Aktif"}
            </div>
            <div className="ttc-session-total">
              {session.status === "PARTIALLY_PAID"
                ? <>₺{Math.round(session.total_amount - (session.paid_amount || 0))} <span className="ttc-kalan">kalan</span></>
                : `₺${Math.round(session.total_amount)}`
              }
            </div>
            <div className="ttc-session-orders">{session.order_count} sipariş</div>
          </div>
        ) : (
          <div className="ttc-empty">Boş</div>
        )}
      </div>
    );
  };

  return (
    <div className="tables-tab">
      <LiveFeed onViewSession={onViewSession} />
      <div className="tables-tab-header">
        <h1 className="panel-title">Masalar</h1>
        <div className="tables-tab-summary">
          <span className="tts-item">
            <span className="tts-label">Toplam</span>
            <span className="tts-value">{tables.length}</span>
          </span>
          <span className="tts-item">
            <span className="tts-label">Aktif</span>
            <span className="tts-value active">{sessions.length}</span>
          </span>
          <span className="tts-item">
            <span className="tts-label">Boş</span>
            <span className="tts-value empty">{tables.length - sessions.length}</span>
          </span>
        </div>
      </div>

      {tables.length === 0 ? (
        <div className="tables-tab-empty">
          <div className="tte-icon"><IcChair size={20} /></div>
          <div className="tte-text">Henüz masa eklenmemiş</div>
          <div className="tte-sub">Yönetici panelinden masa ekleyebilirsiniz</div>
        </div>
      ) : (
        <>
          <div className="tables-tab-section">
            <div className="tts-title">
              <LocLabel type="ic" size={18}>İç Mekan</LocLabel>
              <span className="tts-count">{ic.length} masa</span>
            </div>
            <div className="tables-tab-grid">
              {ic.map(renderTableCard)}
            </div>
          </div>

          {dis.length > 0 && (
            <div className="tables-tab-section">
              <div className="tts-title">
                <LocLabel type="dis" size={18}>Dış Mekan</LocLabel>
                <span className="tts-count">{dis.length} masa</span>
              </div>
              <div className="tables-tab-grid">
                {dis.map(renderTableCard)}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
